module.exports = __webpack_public_path__ + "static/media/information-icon.4917a997.svg";